// extracted by mini-css-extract-plugin
module.exports = {"datatable":"_2uuWC4sS"};